
import {useAppContext} from "./useAppContext";
import {useFragment} from "@apollo/client";
import {QUESTION_STATISTICS_FRAGMENT} from "../definitions/fragments";
import {ItemClassificationType} from "../definitions/enums";
import {useMemo} from "react";

export const useQuestionAndAnswerAccordionHeaderQuery = () => {
    const {productId, primaryId, questionCount: defaultQuestionCount} = useAppContext();
    const {complete, data} = useFragment({
        fragment: QUESTION_STATISTICS_FRAGMENT,
        fragmentName: "QuestionStatisticsFragment",
        from: {
            __typename: "QuestionStatistics",
            id: primaryId ?? productId,
            type: primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone
        }
    });

    const questionCount = useMemo(() => complete ? data?.count ?? defaultQuestionCount : defaultQuestionCount,
        [complete, data, defaultQuestionCount]);

    return {
        title: 'Questions & Answers',
        subtitle: (questionCount ?? 0) === 0 ? undefined : ` (${questionCount})`
    };
}